// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"3fcac686","955":"4e13e508"}[chunkId] + ".chunk.css";
};